// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification {
    background-color: #12871d;
    color: #ffffff;
    padding: 10px;
    margin: 10px;
    border-radius: 5px;
    position: relative;
  }
  
  .close-notification {
    background: none;
    border: none;
    font-size: 16px;
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/Maintenance/Maintenance-styles/Notification.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;EACjB","sourcesContent":[".notification {\n    background-color: #12871d;\n    color: #ffffff;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 5px;\n    position: relative;\n  }\n  \n  .close-notification {\n    background: none;\n    border: none;\n    font-size: 16px;\n    position: absolute;\n    top: 5px;\n    right: 10px;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
